module.exports = __webpack_public_path__ + "static/media/Moe Szyslak.e0e5b79b.png";